export default __webpack_public_path__ + "7fc56cefb359ddbd15ec597a547ba02d.webp";